import React from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import { format } from 'date-fns'
import SimpleFormat from '@16g/react-simple-format'
import BookNowButton from '../../ui/BookNowButton'

@inject("store")
@observer
export default class AvailabilityResult extends React.Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    availableMessage: PropTypes.string.isRequired,
    unavailableMessage: PropTypes.string.isRequired,
    bookNowButtonText: PropTypes.string,
    showCustomBookingUrl: PropTypes.bool,
    customBookingUrl: PropTypes.string
  }

  handleStartOver = (e) => {
    const { store } = this.props

    e.preventDefault()

    store.startOver()
  }

  renderAvailable() {
    const { store, availableMessage, bookNowButtonText, showBookNowButton, showCustomBookingUrl, customBookingUrl } = this.props
    const { activeEventType, franchise } = store
    const { dateFormat } = franchise.attributes
    const formattedEventDate = format(store.activeDate, dateFormat)

    return (
      <div>
        <div className="intro">
          <SimpleFormat text={availableMessage} />
        </div>

        <div className="book-now-wapper">
          <BookNowButton
            eventTypeId={parseInt(activeEventType.id)}
            eventDate={formattedEventDate}
            bookNowButtonText={bookNowButtonText}
            showBookNowButton={showBookNowButton}
            showCustomBookingUrl={showCustomBookingUrl}
            customBookingUrl={customBookingUrl}
          />
        </div>

        <a
          href="#start-over"
          onClick={this.handleStartOver}
          className="start-over"
        >
          { store.allowEditingActiveEventType ?
              "Or check a different date or package" : "Or check a different date"
          }
        </a>
      </div>
    )
  }

  renderUnavailable() {
    const { unavailableMessage } = this.props

    return (
      <div>
        <div className="intro">
          <SimpleFormat text={unavailableMessage} />
        </div>

        <a
          href="#start-over"
          onClick={this.handleStartOver}
          className="start-over"
        >
          Or try a different date or package
        </a>
      </div>
    )

  }

  render() {
    const { store } = this.props
    const { activeEventType, activeDate, availabilityResult } = store
    const { name } = activeEventType.attributes

    return (
      <div className="package-selector">
        <div className="cc-header">
          <div className="cc-title">{ name }</div>
          <div className="cc-subtitle">
            { format(activeDate, store.franchise.attributes.dateFormat) }
          </div>
        </div>

        <div className="cc-content">
          { availabilityResult ?  this.renderAvailable() : this.renderUnavailable() }
        </div>
      </div>
    )
  }
}
